import React from 'react';
import {
    Row,
    Col,
    Button,
    Modal,
    FormControl,
    InputGroup,
    Container,
    Card,
    Figure,
} from 'react-bootstrap';
import '../../Styles.css';
import BuildingIcon from '../../Assets/buildingIcon.png';
import RepairIcon from '../../Assets/repairIcon.png';
import ExpandIcon from '../../Assets/expandIcon.png';
import RetroFitIcon from '../../Assets/plusIcon.png';
import OptimizationIcon from '../../Assets/optIcon.png';
import Path from '../Path/Path';
import t from '../Translations/lang.json';
import axios from 'axios';

const PartnerHome = () => {
    const [requests, setRequests] = React.useState([]);
    const [requestId, setRequestId] = React.useState(0);
    const [requestTitle, setRequestTitle] = React.useState('');
    const [customerName, setCustomerName] = React.useState('');
    const [customerEmail, setCustomerEmail] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [showSupport, setShowSupport] = React.useState(false);
    const [showWarning, setWarning] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(0);

    const [errMsg, setErrMsg] = React.useState('');
    const [seeMore, setSeeMore] = React.useState(false);
    var url = new URL(window.location);
    var lang = url.searchParams.get('language')
        ? url.searchParams.get('language')
        : 'de';
    const currentLang = lang;

    const handleCloseSupport = () => setShowSupport(false);
    const handleCancel = () => setWarning(!showWarning);

    const handleDelete = () => {
        axios({
            url: Path.basePath + '/delete_request.php?req_id=' + deleteItem,
            method: 'GET',
        })
            .then((response) => {
                if (response.data.success === true) {
                    const temp = requests;
                    const filtered = temp.filter((t) => t.id != deleteItem);
                    setRequests(filtered);

                    setWarning(!showWarning);
                    setDeleteItem(0);
                    // alert('Request was Deleted successfully');
                } else {
                    alert('Failed to delete Request');
                }
		window.location.reload(true);
            })
            .catch((err) => console.log(err));
    };

    const handleContactSupport = (request) => {
        setShowSupport(true);
        setRequestId(request.id);
        setCustomerEmail(request.email);
        setRequestTitle(request.request_title);
    };

    const handleShowWarning = (item) => {
        setWarning(!showWarning);
        setDeleteItem(item);
    };

    const handleContactSupportApi = () => {
        const data = {
            name: customerName,
            email: customerEmail,
            message: message,
        };
        axios({
            url: Path.basePath + '/contact_support.php',
            method: 'POST',
            data: JSON.stringify(data),
        }).then((response) => {
            if (response.data.success === true) {
                alert('Email Sent');
                setShowSupport(false);
            }
        });
        // console.log(data);
    };

    React.useEffect(() => {
        const url = new URL(window.location.href);
        const email = url.searchParams.get('user_email');

        axios({
            url: Path.basePath + '/customer_requests.php?email=' + email,
            method: 'GET',
        })
            .then((response) => {
                if (response.data.success === true) {
                    if (response.data.data.length > 0) {
                        setRequests(response.data.data);
                        setRequestId(response.data.data.id);
                    } else {
                        setErrMsg('No Record Found');
                    }
                }
            })
            .catch((err) => console.log(err));
    }, []);
    return (
        <Container>
            <Row className='d-flex  mt-5 mb-3'>
                <Col xs={12} lg={6}>
                    <h5 className={'custm-title mt-1'}>
                        {t[currentLang].titleCustomerHome}
                    </h5>
                </Col>
            </Row>
            {requests.length > 0 ? (
                requests.map((item, index) => (
                    <Row className='mt-3' key={index}>
                        <Col sm={12} lg={12}>
                            <Card className='card'>
                                <Row className='no-gutters'>
                                    <Col xs={12} sm={12} md={8} lg={8}>
                                        <Card.Body>
                                            <Row className='ml-1 mb-2'>
                                                <h4>{item.request_title}</h4>
                                            </Row>
                                            <Row>
                                                <Col
                                                    xs={12}
                                                    sm={12}
                                                    md={4}
                                                    lg={3}
                                                    className='d-flex align-items-center'
                                                >
                                                    <Card className='figure-card'>
                                                        <Card.Body>
                                                            <Figure>
                                                                <Figure.Image
                                                                    width={170}
                                                                    height={10}
                                                                    alt='171x180'
                                                                    src={
                                                                        item.service ==
                                                                        'newbuilding'
                                                                            ? BuildingIcon
                                                                            : item.service ==
                                                                              'expand'
                                                                            ? ExpandIcon
                                                                            : item.service ==
                                                                              'retrofit'
                                                                            ? RetroFitIcon
                                                                            : item.service ==
                                                                              'optimization'
                                                                            ? OptimizationIcon
                                                                            : item.service ==
                                                                              'repair'
                                                                            ? RepairIcon
                                                                            : ''
                                                                    }
                                                                />
                                                                <Figure.Caption className='text-center '>
                                                                    {item.service ==
                                                                    'newbuilding'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .newBuilding
                                                                        : item.service ==
                                                                          'expand'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .expand
                                                                        : item.service ==
                                                                          'retrofit'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .retrofit
                                                                        : item.service ==
                                                                          'optimization'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .optimization
                                                                        : item.service ==
                                                                          'repair'
                                                                        ? t[
                                                                              currentLang
                                                                          ]
                                                                              .repair
                                                                        : ''}
                                                                </Figure.Caption>
                                                            </Figure>
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                                <Col xs={12} md={8} lg={9}>
                                                    <div className='mb-3'>
                                                        <p>
                                                            {seeMore ===
                                                                false &&
                                                            item.description
                                                                .length > 270
                                                                ? item.description.substring(
                                                                      0,
                                                                      270
                                                                  )
                                                                : item.description}
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#7FA43F',
                                                                    fontWeight: 600,
                                                                }}
                                                                onClick={() =>
                                                                    seeMore ===
                                                                    false
                                                                        ? setSeeMore(
                                                                              true
                                                                          )
                                                                        : setSeeMore(
                                                                              false
                                                                          )
                                                                }
                                                            >
                                                                {seeMore ===
                                                                    false &&
                                                                item.description
                                                                    .length >
                                                                    270
                                                                    ? '... see more'
                                                                    : seeMore ===
                                                                          true &&
                                                                      item
                                                                          .description
                                                                          .length >
                                                                          270
                                                                    ? '(see less...)'
                                                                    : ''}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0 p-0'>
                                                            {
                                                                t[currentLang]
                                                                    .pDurationHeading
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.deadline ==
                                                            'timeley'
                                                                ? t[currentLang]
                                                                      .timely
                                                                : item.deadline ==
                                                                  '30days'
                                                                ? t[currentLang]
                                                                      .thirtyDays
                                                                : item.deadline ==
                                                                  '3months'
                                                                ? t[currentLang]
                                                                      .threeMonth
                                                                : item.deadline ==
                                                                  '3or6months'
                                                                ? t[currentLang]
                                                                      .threeSixMonth
                                                                : item.deadline ==
                                                                  'morethan6'
                                                                ? t[currentLang]
                                                                      .morethan6
                                                                : item.deadline}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .pPostalCodeHeading
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.postal_code}
                                                        </p>
                                                    </div>
                                                    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .pFullNameHeading
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.full_name}
                                                        </p>
                                                    </div>
						    <div
                                                        className='d-flex request-info'
                                                        // style={{
                                                        //     height: '30px',
                                                        // }}
                                                    >
                                                        <h6 className='w-32 mb-0'>
                                                            {
                                                                t[currentLang]
                                                                    .requestDate
                                                            }
                                                        </h6>
                                                        <p className='ml-5 align-content-center'>
                                                            {item.created_at.substr(0,10).split('-').reverse().join(".")}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Col>
                                    <Col
                                        sm={12}
                                        md={4}
                                        lg={4}
                                        className='card-right-sec d-flex flex-column'
                                    >
                                        <Card.Body className='d-flex flex-column justify-content-center'>
                                            <p className='m-2 mt-0 mb-4 text-justify'>
                                                {
                                                    t[currentLang]
                                                        .custPortalDescTxt
                                                }
                                            </p>
                                            <button
                                                // variant='success'
                                                className='button  rounded mb-2'
                                                size='lg'
                                                block
                                                onClick={() => {
                                                    handleContactSupport(item);
                                                }}
                                            >
                                                {
                                                    t[currentLang]
                                                        .contactSupportCust
                                                }
                                            </button>
                                            <button
                                                // variant='success'
                                                className='button-outlined rounded'
                                                size='lg'
                                                block
                                                onClick={() => {
                                                    handleShowWarning(item.id);
                                                }}
                                            >
                                                {t[currentLang].delete}
                                            </button>
                                        </Card.Body>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                ))
            ) : (
                <Row className='mt-3' key={0}>
                    <Col sm={12} lg={12}>
                        {errMsg && (
                            <Card className='card'>
                                <Row className='no-gutters'>
                                    <Col sm={8} lg={8}>
                                        <Card.Body>
                                            <Row className='ml-1 mb-2'>
                                                <h4>{errMsg}</h4>
                                            </Row>
                                        </Card.Body>
                                    </Col>
                                </Row>
                            </Card>
                        )}
                    </Col>
                </Row>
            )}
            <Modal
                show={showSupport}
                onHide={handleCloseSupport}
                backdrop='static'
                keyboard={false}
            >
                <button
                    style={{
                        backgroundColor: '#7fa43f',
                        width: 30,
                        height: 30,
                        textAlign: 'center',
                        position: 'absolute',
                        top: -12,
                        right: -12,
                        borderRadius: 20,
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 20,
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: 'none',
                    }}
                    onClick={handleCloseSupport}
                >
                    x
                </button>
                <Modal.Body style={{ paddingTop: 30 }}>
                    <Row>
                        <Col lg={6} sm={8}>
                            <FormControl
                                defaultValue={requestTitle}
                                placeholder='Reply to ‚Test Extension‘ [Title] '
                                aria-label='title'
                                className='input-field'
                                disabled
                            />
                        </Col>
                        <Col lg={6} sm={4} className='align-self-center rqt-id'>
                            <h6>{t[currentLang].requestId} #{requestId}</h6>
                        </Col>
                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].fromTxt}
                                aria-label='title'
                                className='input-field mt-2'
                                onChange={(event) =>
                                    // console.log(event.target.value)
                                    setCustomerName(event.target.value)
                                }
                            />
                        </Col>

                        <Col lg={12} sm={12}>
                            <FormControl
                                defaultValue=''
                                placeholder={t[currentLang].messageTxt}
                                className='input-field mt-2'
                                as='textarea'
                                rows={8}
                                onChange={(e) => setMessage(e.target.value)}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className='modal-button btn'
                        onClick={handleContactSupportApi}
                    >
                        {t[currentLang].sendQuery}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showWarning}
                onHide={handleCancel}
                backdrop='static'
                keyboard={false}
            >
                {/* <button
                    style={{
                        backgroundColor: '#7fa43f',
                        width: 30,
                        height: 30,
                        textAlign: 'center',
                        position: 'absolute',
                        top: -12,
                        right: -12,
                        borderRadius: 20,
                        color: '#fff',
                        fontWeight: 'bold',
                        fontSize: 20,
                        zIndex: 9999,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: 'none',
                    }}
                    onClick={handleCancel}
                >
                    x
                </button> */}
                <Modal.Body style={{ paddingTop: 30 }}>
                    <Row>
                        <Col
                            lg={12}
                            sm={12}
                            style={{ paddingTop: 20, paddingBottom: 20 }}
                        >
                            {t[currentLang].warningTxt}
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='modal-button btn' onClick={handleDelete}>
                        {t[currentLang].delete}
                    </Button>
                    <Button
                        variant='contained'
                        className='btn'
                        onClick={handleCancel}
                    >
                        {t[currentLang].cancel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};
export default PartnerHome;
